// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import { AlertTriangle } from 'lucide-react'
import ConfirmDialog from '../ui/ConfirmDialog'

/**
 * BA-27: destructive-action confirmation that cannot be triggered by a stray double-Enter — the user
 * must type DELETE (exact, uppercase) before the confirm button arms.
 *
 * D-UI-3 c3: now a thin wrapper over the shared ConfirmDialog (focus trap, Esc, labelled alert dialog).
 * Same props, so its callers (Secure Share, Documents) are unchanged.
 */
export default function TypedDeleteConfirm({
  open, title, message, confirmWord = 'DELETE', busy, error, onConfirm, onCancel,
}: {
  open: boolean
  title: string
  message: string
  confirmWord?: string
  busy?: boolean
  /** The delete's failure, shown inside the dialog (the page behind is covered by it). */
  error?: string | null
  onConfirm: () => void
  onCancel: () => void
}) {
  return (
    <ConfirmDialog open={open} tone="danger" busy={busy} error={error} typedConfirm={confirmWord}
      confirmLabel="Delete permanently" busyLabel="Deleting…"
      title={<span style={{ display: 'inline-flex', alignItems: 'center', gap: 10, color: '#b91c1c' }}><AlertTriangle size={18} /> {title}</span>}
      body={<>
        <p style={{ margin: '0 0 6px' }}>{message}</p>
        <p style={{ margin: 0, fontSize: 13, color: 'var(--color-text-soft, #555)' }}>
          This action <strong>cannot be undone and the document cannot be restored.</strong>
        </p>
      </>}
      onConfirm={() => onConfirm()} onCancel={onCancel} />
  )
}
